import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="bg-dark text-white p-5 mt-5">
        <h6>@ 2022-2025; All reserved by Quiz Hunter</h6>
      </div>
    </div>
  );
};

export default Footer;
